(function () {
  'use strict';

  function shuffleArray(arr) {
    for (var i = arr.length - 1; i > 0; i--) {
      var j = Math.floor(Math.random() * (i + 1));
      var tmp = arr[i];
      arr[i] = arr[j];
      arr[j] = tmp;
    }
    return arr;
  }

  function roundRobinOrder(items) {
    var groups = new Map();
    items.forEach(function (item) {
      var pid = item.getAttribute('data-product-id') || item;
      if (!groups.has(pid)) groups.set(pid, []);
      groups.get(pid).push(item);
    });

    var groupArrays = Array.from(groups.values()).map(function (g) {
      return shuffleArray(g.slice());
    });
    shuffleArray(groupArrays);

    var result = [];
    var remaining = true;
    while (remaining) {
      remaining = false;
      for (var i = 0; i < groupArrays.length; i++) {
        var group = groupArrays[i];
        var next = group.shift();
        if (next) {
          result.push(next);
          if (group.length) remaining = true;
        }
      }
    }
    return result;
  }

  function shuffleWithinParent(parent, items) {
    var ordered = roundRobinOrder(items);
    var fragment = document.createDocumentFragment();
    ordered.forEach(function (el) {
      fragment.appendChild(el);
    });
    parent.appendChild(fragment);
  }

  function observeParent(parent) {
    if (parent.__shuffleObserved) return;
    parent.__shuffleObserved = true;

    var observer = new MutationObserver(function (mutations) {
      var added = [];
      mutations.forEach(function (m) {
        m.addedNodes.forEach(function (n) {
          if (n.nodeType === 1 && n.classList && n.classList.contains('product-grid__item')) {
            added.push(n);
          }
        });
      });
      if (added.length) shuffleWithinParent(parent, added);
    });

    observer.observe(parent, { childList: true });
  }

        function init() {
        var items = Array.prototype.slice.call(document.querySelectorAll('.product-grid__item'));
        if (!items.length) return;

        var byParent = new Map();
        items.forEach(function (item) {
            var parent = item.parentElement;
            if (!parent) return;
            if (!byParent.has(parent)) byParent.set(parent, []);
            byParent.get(parent).push(item);
        });

        byParent.forEach(function (children, parent) {
            shuffleWithinParent(parent, children);
            parent.setAttribute('data-shuffled', '');
            observeParent(parent);
        });
        }

        // Red de seguridad: si por lo que sea el reordenamiento no llega a
        // ejecutarse (error de JS, script bloqueado, etc.), no dejamos la
        // cuadrícula invisible para siempre.
        setTimeout(function () {
        var grids = document.querySelectorAll('.product-grid:not([data-shuffled])');
        grids.forEach(function (g) {
            g.setAttribute('data-shuffled', '');
        });
        }, 1500);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();